import { EmptyState } from '@frontapp/ui-kit';
import AccountInfo from './AccountInfo';
import SsoUserInfo from './SsoUserInfo';
import type { ProfileResponse } from './types';

type Props = {
  response: ProfileResponse;
};

function Profile({ response }: Props) {
  if (
    !response.account &&
    !response.sso_user &&
    response.related_accounts.length === 0
  ) {
    return (
      <div style={{ height: '200px' }}>
        <EmptyState />
      </div>
    );
  }
  return (
    <>
      {response.account && <AccountInfo account={response.account} />}
      {response.sso_user && <SsoUserInfo ssoUser={response.sso_user} />}
      {response.related_accounts.map((account) => (
        <AccountInfo key={account.id} account={account} />
      ))}
    </>
  );
}

export default Profile;
